export function isSubstring(sub: string, full: string): boolean {
  return sub.toUpperCase().includes(full.toUpperCase());
}
